"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = exports.getLegalStateTransitionPath = exports.toIndexedObject = exports.getCurrentState = void 0;
const consts_1 = require("./consts");
const enums_1 = require("./enums");
/**
 * Возвращает текущее состояние
 */
const getCurrentState = () => {
    if (!exports.isBrowser) {
        return enums_1.LifecycleState.UNKNOWN;
    }
    if (document.visibilityState === enums_1.LifecycleState.HIDDEN) {
        return enums_1.LifecycleState.HIDDEN;
    }
    if (document.hasFocus()) {
        return enums_1.LifecycleState.ACTIVE;
    }
    return enums_1.LifecycleState.PASSIVE;
};
exports.getCurrentState = getCurrentState;
/**
 * Преобразует массив состояний в объект, где состояние является ключом, а значение является индексом.
 */
const toIndexedObject = (arr) => arr.reduce((acc, val, idx) => {
    acc[val] = idx;
    return acc;
}, {});
exports.toIndexedObject = toIndexedObject;
/**
 * Принимает текущее состояние и будущее состояние и возвращает массив допустимых путей перехода состояния.
 * Это необходимо для нормализации поведения в разных браузерах,
 * поскольку некоторые браузеры в определенных случаях не запускают события и, таким образом, пропускают состояния.
 */
const getLegalStateTransitionPath = (oldState, newState) => {
    const stateTransitions = consts_1.LEGAL_STATE_TRANSITIONS.map(exports.toIndexedObject);
    for (const order of stateTransitions) {
        const oldIndex = order[oldState];
        const newIndex = order[newState];
        if (oldIndex !== undefined && newIndex !== undefined && newIndex > oldIndex) {
            return Object.keys(order).slice(oldIndex, newIndex + 1);
        }
    }
    // в целом сюда попасть мы никогда не должны.
    return [];
};
exports.getLegalStateTransitionPath = getLegalStateTransitionPath;
/**
 * Проверка среды.
 */
exports.isBrowser = typeof window !== 'undefined';
